export default __webpack_public_path__ + "static/media/feature.fa11fc48.png";